import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, Typography, Avatar, } from '@material-ui/core';
import gradients from 'src/utils/gradients';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  avatar: {
    backgroundImage: gradients.green,
    height: 48,
    width: 48
  }
}));

function MoneyDisplay({ className, text, value }) {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <div>
        <Typography
          component="h3"
          gutterBottom
          variant="overline"
        >
          {text}
        </Typography>
        <div className={classes.details}>
          <Typography variant="h3">

            {value}
          </Typography>
        </div>
      </div>
      <Avatar className={classes.avatar} />
    </Card>
  );
}

MoneyDisplay.propTypes = {
  className: PropTypes.string
};

export default MoneyDisplay;
